// 盤面装飾タイル（見栄え用。ゲームロジックには影響しない）
import { BOARD_SIZE } from './board.ts'
import dirtPlain from '../assets/tiles/dirt_plain.png'
import flowerRed from '../assets/tiles/flower_red.png'
import flowerYellow from '../assets/tiles/flower_yellow.png'
import grassBright from '../assets/tiles/grass_bright.png'
import grassDark from '../assets/tiles/grass_dark.png'
import fieldFruiting from '../assets/tiles/field_fruiting.svg'
import fieldSeedling from '../assets/tiles/field_seedling.svg'
import paddyGolden from '../assets/tiles/paddy_golden.svg'
import paddySprout from '../assets/tiles/paddy_sprout.png'
import paddyWater from '../assets/tiles/paddy_water.png'
import stoneBoulder from '../assets/tiles/stone_boulder_soft.svg'
import stonePebble from '../assets/tiles/stone_pebble.png'
import treeSingle from '../assets/tiles/tree_single.png'
import treeStump from '../assets/tiles/tree_stump_soft.svg'
import waterPond from '../assets/tiles/water_pond.png'
import canalHorizontal from '../assets/tiles/canal_horizontal.svg'
import canalVertical from '../assets/tiles/canal_vertical.svg'
import canalCornerNe from '../assets/tiles/canal_corner_ne.svg'
import canalCornerNw from '../assets/tiles/canal_corner_nw.svg'
import canalCornerSe from '../assets/tiles/canal_corner_se.svg'
import canalCornerSw from '../assets/tiles/canal_corner_sw.svg'
import canalCross from '../assets/tiles/canal_cross.svg'
import canalTN from '../assets/tiles/canal_t_n.svg'
import canalTE from '../assets/tiles/canal_t_e.svg'
import canalTS from '../assets/tiles/canal_t_s.svg'
import canalTW from '../assets/tiles/canal_t_w.svg'

export type TileId =
  | 'grass_bright'
  | 'grass_dark'
  | 'dirt_plain'
  | 'field_seedling'
  | 'field_fruiting'
  | 'paddy_sprout'
  | 'paddy_water'
  | 'paddy_golden'
  | 'flower_red'
  | 'flower_yellow'
  | 'stone_pebble'
  | 'stone_boulder'
  | 'tree_single'
  | 'tree_stump'
  | 'water_pond'
  | 'canal_horizontal'
  | 'canal_vertical'
  | 'canal_corner_ne'
  | 'canal_corner_nw'
  | 'canal_corner_se'
  | 'canal_corner_sw'
  | 'canal_cross'
  | 'canal_t_n'
  | 'canal_t_e'
  | 'canal_t_s'
  | 'canal_t_w'

export type TileMap = TileId[][]

// タイル ID → 画像 URL
export const TILE_IMAGES: Record<TileId, string> = {
  grass_bright: grassBright,
  grass_dark: grassDark,
  dirt_plain: dirtPlain,
  field_seedling: fieldSeedling,
  field_fruiting: fieldFruiting,
  paddy_sprout: paddySprout,
  paddy_water: paddyWater,
  paddy_golden: paddyGolden,
  flower_red: flowerRed,
  flower_yellow: flowerYellow,
  stone_pebble: stonePebble,
  stone_boulder: stoneBoulder,
  tree_single: treeSingle,
  tree_stump: treeStump,
  water_pond: waterPond,
  canal_horizontal: canalHorizontal,
  canal_vertical: canalVertical,
  canal_corner_ne: canalCornerNe,
  canal_corner_nw: canalCornerNw,
  canal_corner_se: canalCornerSe,
  canal_corner_sw: canalCornerSw,
  canal_cross: canalCross,
  canal_t_n: canalTN,
  canal_t_e: canalTE,
  canal_t_s: canalTS,
  canal_t_w: canalTW,
}

// 出現重み（相対値、合計はランタイムで正規化）
// 草・土をベースに多めにして、花や木・池はアクセントとして低頻度。
export const TILE_WEIGHTS: Record<TileId, number> = {
  grass_bright: 30,
  grass_dark: 25,
  dirt_plain: 18,
  field_seedling: 7,
  field_fruiting: 0,
  paddy_sprout: 4,
  paddy_water: 3,
  paddy_golden: 0,
  stone_pebble: 5,
  stone_boulder: 3,
  flower_red: 3,
  flower_yellow: 3,
  tree_single: 2,
  tree_stump: 2,
  water_pond: 2,
  canal_horizontal: 2,
  canal_vertical: 2,
  canal_corner_ne: 1,
  canal_corner_nw: 1,
  canal_corner_se: 1,
  canal_corner_sw: 1,
  canal_cross: 1,
  canal_t_n: 1,
  canal_t_e: 1,
  canal_t_s: 1,
  canal_t_w: 1,
}

// マップを空扱いで初期化（タイトル画面用。ベースタイル1種で埋める）
export const DEFAULT_TILE: TileId = 'grass_bright'

export function resolveTileImage(id: TileId, turnCount: number): string {
  if ((id === 'paddy_sprout' || id === 'paddy_water') && turnCount >= 28) {
    return TILE_IMAGES.paddy_golden
  }
  if (id === 'field_seedling' && turnCount >= 28) {
    return TILE_IMAGES.field_fruiting
  }
  return TILE_IMAGES[id]
}

export function createEmptyMap(): TileMap {
  return Array.from({ length: BOARD_SIZE }, () =>
    Array<TileId>(BOARD_SIZE).fill(DEFAULT_TILE)
  )
}
